import type { GetSucursalByDomainParams, GetSucursalByDomainResponse } from '@contracts/api/sucursales'
import { api } from './api'

export const getSucursalByDomain = async (
    params: GetSucursalByDomainParams
): Promise<GetSucursalByDomainResponse> => {
    const { data } = await api.get<GetSucursalByDomainResponse>('api/v1/sucursales/por-dominio', {
        params,
    })
    return data
}
